import { strongPassword } from '@shopee/validators';

export const FORM_CONFIG = [
  {
    name: 'password',
    initial: '',
    validators: [strongPassword('label_auth_password_is_weak')],
  },
];
